'use client';

import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';

const App = dynamic(() => import('./App'), { ssr: false });

const ClientApp = ({ children }: PropsWithChildren) => <App>{children}</App>;

export default ClientApp;
